export default __webpack_public_path__ + "static/media/landing_page_bg.01660966.png";